<template>
  <div></div>
</template>
<script>
export default {
  name: 'EmptyView',
};
</script>
